import { css } from '@emotion/react'
import moment from 'moment/moment';
 /** @jsxImportSource @emotion/react */
import React from 'react'
import { useLocation } from 'react-router-dom'

export default function MemberDetail() {
  const location = useLocation();
  console.log("location.state",location.state)
  const {username,full_name,commission,phone_number,timezone,created_at} = location.state;
  return (
    <div style={{paddingLeft: "0.5rem"}}>
      <h2 style={{fontWeight: 'normal'}}>Member Detail</h2>
      <div  css={css`
            /* background-color: #EEEEEE; */
            padding: 2rem;
            border-radius: 1rem;
            margin-top: 1rem;
            box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
        `}>
        <div style={{display: "flex",marginBottom: "1rem"}}>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: 'grey'}}>Username</h3>
            <h3 style={{fontWeight: "normal"}}>{username}</h3>
          </div>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: "grey"}}>Phone No.</h3>
            <h3 style={{fontWeight: "normal"}}>{phone_number}</h3>
          </div>
        </div>
        <div style={{display: "flex",marginBottom: "1rem"}}>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: 'grey'}}>Full Name</h3>
            <h3 style={{fontWeight: "normal"}}>{full_name}</h3>
          </div>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: "grey"}}>Commision</h3>
            <h3 style={{fontWeight: "normal"}}>{commission}</h3>
          </div>
        </div>
        <div style={{display: "flex"}}>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: 'grey'}}>TimeZone</h3>
            <h3 style={{fontWeight: "normal"}}>{timezone}</h3>
          </div>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: "grey"}}>Join Date</h3>
            <h3 style={{fontWeight: "normal"}}>{moment(created_at).format('MM-DD-YYYY h:mmA')}</h3>
          </div>
        </div>
      </div>
    </div>
  )
}
